import { useState, useEffect } from 'react';
import { useAppSelector } from 'utilities/hooks';
import { ModeDocumentsPageType } from '../types';

export const useLoadingDocumentsPage = ({ mode = 'documents' }: { mode?: ModeDocumentsPageType } = {}) => {
    const { loading: documentsLoading } = useAppSelector((state) => state.documents);
    const { loading: categoriesLoading } = useAppSelector((state) => state.categories);
    const [loading, setLoading] = useState(documentsLoading || categoriesLoading);

    useEffect(() => {
        setLoading(documentsLoading || categoriesLoading);
    }, [documentsLoading, categoriesLoading]);

    return loading;
};
